// src/types/auth.js
import { PERMISSIONS as CONST_PERMISSIONS, ROLES } from "../constants/permissions";

/**
 * Predefined System Roles matching backend ROLE enum
 */
export const RoleId = ROLES;
export { ROLES };

/**
 * Granular Permission keys matching backend PERMISSIONS
 */
export const PERMISSIONS = CONST_PERMISSIONS;

/**
 * Human-readable mapping of role names
 */
export const ROLE_NAMES = Object.freeze({
  [RoleId.SUPER_ADMIN]: "Super Admin",
  [RoleId.HOSPITAL_ADMIN]: "Hospital Admin",
  [RoleId.DOCTOR]: "Doctor",
  [RoleId.STAFF]: "Staff",
  [RoleId.NURSE]: "Nurse",
  [RoleId.LAB_TECHNICIAN]: "Lab Technician",
  [RoleId.PHARMACIST]: "Pharmacist",
  [RoleId.BILLING]: "Billing Officer",
  [RoleId.RECEPTIONIST]: "Receptionist",
  [RoleId.DEPARTMENT_HEAD]: "Department Head",
  [RoleId.AUDITOR]: "Auditor",
});

/**
 * @typedef {typeof PERMISSIONS[keyof typeof PERMISSIONS]} Permission
 */

/**
 * @typedef {Object} AuthUser
 * @property {string} id
 * @property {string} name
 * @property {string} email
 * @property {number} role_id
 * @property {string} role_name
 * @property {string} [hospital_id]
 * @property {string} [department_id]
 * @property {boolean} is_super_admin
 * @property {string[]} permissions
 */

/**
 * @typedef {Object} RoleDefinition
 * @property {number} role_id
 * @property {string} name
 * @property {string} description
 * @property {string[]} permissions
 * @property {number} total_permissions
 * @property {boolean} status
 */
